import type { ProductoLinea } from './facturaFormTypes';

/** Totales por línea: `precio` es precio de venta en COP (con IVA incluido si `iva_porcentaje` > 0). */
export function lineEconomicBreakdown(p: Pick<ProductoLinea, 'precio' | 'qty' | 'iva_porcentaje'>) {
  const qty = p.qty;
  const precio = p.precio;
  const ivaPct = Math.max(0, Number(p.iva_porcentaje ?? 0) || 0);
  if (ivaPct <= 0) {
    const con = precio * qty;
    return {
      subtotalSinIva: con,
      totalIva: 0,
      subtotalConIva: con,
      ivaPorcentaje: 0,
    };
  }
  const unitSinIva = precio / (1 + ivaPct / 100);
  const unitIva = precio - unitSinIva;
  return {
    subtotalSinIva: unitSinIva * qty,
    totalIva: unitIva * qty,
    subtotalConIva: precio * qty,
    ivaPorcentaje: ivaPct,
  };
}
